let f_speechSynthesizerTimestamp = null;

import localforage from 'localforage';
import {
    FJRelationBetweenSpeechServiceAndLocalization,
    FJVoiceBetweenSpeechServiceAndLocalization,
} from '../config/dataConfig/FJSpeechServiceLanguageConfig';
import FJNetworkStore from './FJNetworkStore';
import FJLocalStore from './FJLocalStore';
import FJUtil from '../util/FJUtil';
import FJConfig from '../config/FJConfig';
class FJTextToSpeechManager {
    constructor() {
        this._voiceObj = null;
        this._voiceStyleObj = null;
        this._initLanguage = null;
        this._languageList = null;
    }
    async _getVoiceList() {
        const token = await FJNetworkStore.getVoiceServiceToken();
        const TTSVoiceList = await FJNetworkStore.getVoiceList(token);
        return TTSVoiceList;
    }
    async _getVoiceWavList() {
        const voiceList = await FJNetworkStore.getTextToSpeechVoices();
        return voiceList;
    }
    async _updateList() {
        let TTSVoiceList = null;
        let voiceList = null;
        try {
            TTSVoiceList = await localforage.getItem('TTSVoiceList');
            if (!TTSVoiceList) {
                TTSVoiceList = await this._getVoiceList();
                localforage.setItem('TTSVoiceList', TTSVoiceList);
            }

            let TTSVoiceWavData = await localforage.getItem('TTSVoiceWavData');
            if (!TTSVoiceWavData) {
                voiceList = await this._getVoiceWavList();
                localforage.setItem('TTSVoiceWavData', {
                    TTSVoiceWavData: voiceList,
                    version: FJConfig.textToSpeechVoicesVersion,
                });
            } else {
                if (TTSVoiceWavData.version !== FJConfig.textToSpeechVoicesVersion) {
                    voiceList = await this._getVoiceWavList();
                    localforage.setItem('TTSVoiceWavData', {
                        TTSVoiceWavData: voiceList,
                        version: FJConfig.textToSpeechVoicesVersion,
                    });
                } else {
                    voiceList = TTSVoiceWavData.TTSVoiceWavData;
                }
            }
        } catch (error) {
            TTSVoiceList = await this._getVoiceList();
            voiceList = await this._getVoiceWavList();
        }

        const { langList, voiceObj, styleObj } = this.dealVoiceList(TTSVoiceList, voiceList);
        // 文字转语音默认角色修改，并且对应的声音应该置顶
        for (let key in FJRelationBetweenSpeechServiceAndLocalization) {
            const languageCode = FJRelationBetweenSpeechServiceAndLocalization[key];
            const enList = [...voiceObj[languageCode]];
            const voiceId = FJVoiceBetweenSpeechServiceAndLocalization[key];
            const index = enList.findIndex(obj => obj.id === voiceId);
            if (index !== -1) {
                FJUtil.elevateArrayFromIndex(enList, index);
                voiceObj[languageCode] = enList;
            }
        }

        const currentTag = FJLocalStore.currentTag();
        let language = FJRelationBetweenSpeechServiceAndLocalization[currentTag];

        this._voiceObj = voiceObj;
        this._voiceStyleObj = styleObj;
        this._initLanguage = language;
        this._languageList = langList;
    }
    async getListInfo() {
        if (!(this._voiceObj && this._voiceStyleObj && this._initLanguage && this._languageList))
            await this._updateList();
        return {
            voiceObj: this._voiceObj,
            styleObj: this._voiceStyleObj,
            language: this._initLanguage,
            langList: this._languageList,
        };
    }
    getTTSInfoByLang(languageValue) {
        const voiceList = this._voiceObj[languageValue];
        const voiceStyleList = this._voiceStyleObj[voiceList[0].value] || [];
        const voiceValue = voiceList[0].value;
        const voiceStyleValue = voiceStyleList[0] ? voiceStyleList[0].id : '';
        return { voiceList, voiceStyleList, voiceValue, voiceStyleValue };
    }
    getTTSInfoByVoice(voiceValue) {
        const voiceStyleList = this._voiceStyleObj[voiceValue] || [];
        const voiceStyleValue = voiceStyleList[0] ? voiceStyleList[0].id : '';
        return { voiceStyleList, voiceStyleValue };
    }
    dealVoiceList(voiceList, wavList) {
        // 排序
        const sorted = voiceList.sort(function (a, b) {
            return `${a.LocaleName}${a.VoiceType}`.localeCompare(`${b.LocaleName}${b.VoiceType}`);
        });

        let langList = [],
            voiceObj = {},
            styleObj = {},
            rolePlayObj = {},
            secondaryObj = {};

        for (let i = 0; i < sorted.length; i++) {
            const element = sorted[i];
            let displayName = element.DisplayName;

            // 已经弃用
            if (element.Status === 'Deprecated') {
                continue;
            }

            if (!voiceObj[element.Locale]) {
                voiceObj[element.Locale] = [];
                langList.push({
                    value: element.Locale,
                    label: element.LocaleName,
                    languageKey: `${element.Locale.toLowerCase()}-speech-service`,
                });
            }

            // // 需求要求去掉(Neural)
            // if (element.VoiceType === 'Neural') {
            //     displayName += ' (Neural)';
            // }

            if (element.LocalName !== element.DisplayName) {
                displayName += ' - ' + element.LocalName;
            }

            // 不需要显示预览
            // if (element.Status === 'Preview') {
            //     displayName += ' - ' + localizedResources.ttsPreview;
            // }

            const findWavItem = wavList.find(item => item.ShortName === element.ShortName);
            const styleSamples = findWavItem ? findWavItem.styleSamples : [];

            voiceObj[element.Locale].push({
                value: element.ShortName,
                label: displayName,
                id: element.ShortName,
                text: displayName,
                gender: element.Gender,
                url: styleSamples[0]?.audioFileEndpointWithSas,
            });

            // 如果音频有问题就不显示播放按钮
            try {
                let styleList = [];
                if (element.StyleList) {
                    styleList = element.StyleList.map(item => {
                        const findItem = styleSamples.find(sample => sample.styleName === item);
                        return { id: item, text: item, url: findItem?.audioFileEndpointWithSas };
                    });
                    styleList.unshift({
                        id: 'general',
                        text: 'general',
                        url: styleSamples[0]?.audioFileEndpointWithSas,
                    });
                } else {
                    styleList = [{ id: 'general', text: 'general', url: styleSamples[0]?.audioFileEndpointWithSas }];
                }
                styleObj[element.ShortName] = styleList;
            } catch (e) {
                styleObj[element.ShortName] = element.StyleList
                    ? element.StyleList.map(item => {
                          return { id: item, text: item };
                      })
                    : [{ id: 'general', text: 'general' }];
            }

            rolePlayObj[element.ShortName] = element.RolePlayList;
            secondaryObj[element.ShortName] = element.SecondaryLocaleList;
        }

        return {
            langList,
            voiceObj,
            styleObj,
            rolePlayObj,
            secondaryObj,
        };
    }
    _isInterrupt(timestamp) {
        return timestamp !== f_speechSynthesizerTimestamp;
    }
    interrupt() {
        f_speechSynthesizerTimestamp = null;
    }
}
let client = new FJTextToSpeechManager();
window.client = client;
export default client;
